/* eslint-disable */
import Vue from "vue";
import store from "../store";
import { appInsights } from './applicationInsights';
import { notify } from '../shared/notifications';
import { hasValidationErrors, validationMessage } from '../helpers/api-validation-error.helper';

export class Request {

    static buildUrl(requestUrl, params = null) {        
        var url = new URL(requestUrl)
        if (params != null)
            Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));
        
        return url;
    }

    static buildSetting(request, headers = null, body = null) {
        var setting = {
            method: request,
        }
        if (body != null)
        {
            setting.body = JSON.stringify(body);
        }

        setting.headers = headers != null ? new Headers(headers) : new Headers();
        setting.headers.append("Content-Type", "application/json");
        if (localStorage.token)
        {            
            setting.headers.append('Authorization', 'Bearer ' + localStorage.token)
        }
        return setting;
    }

    static put(requestUrl, body, queryParams = null, headers = null) {
        var url = this.buildUrl(requestUrl, queryParams)
        var setting = this.buildSetting('PUT', headers, body)
        return fetch(url, setting).then(e => e.ok ? e.json() : this.preocessError(e));
    }

    static post(requestUrl, body, queryParams = null, headers = null) {
        var url = this.buildUrl(requestUrl, queryParams)
        var setting = this.buildSetting('POST', headers, body)
        return fetch(url, setting).then(res => this.proccessResponse(res));
    }

    static get(requestUrl, queryParams = null, headers = null) {        
        var url = this.buildUrl(requestUrl, queryParams)
        var setting = this.buildSetting('GET', headers)

        return this.fetchWithAuth(url, setting);
    }

    static delete(requestUrl, queryParams = null, headers = null) {
        var url = this.buildUrl(requestUrl, queryParams)
        var setting = this.buildSetting('DELETE', headers)
        return fetch(url, setting).then(response => response.ok ? response.json() : this.preocessError(e));
    }

    static getBlob(requestUrl, queryParams = null, headers = null) {
        var url = this.buildUrl(requestUrl, queryParams)
        var setting = {
            method: "GET",
            headers : headers != null ? new Headers(headers) : new Headers()
        }  
        if (localStorage.token)
            setting.headers.append('Authorization', 'Bearer ' + localStorage.token)
        return fetch(url, setting).then(e => e.ok ? e.blob() : this.preocessError(e));
    }

    static postMultipartData(requestUrl,formData,queryParams=null,headers=null){
        var url = this.buildUrl(requestUrl,queryParams)
        var setting = {
            method: 'POST',
            body : formData
        }   
        setting.headers = headers!=null ? new Headers(headers) : new Headers(); 
        if(localStorage.token)
            setting.headers.append('Authorization','Bearer '+localStorage.token) 
        return fetch(url,setting).then(e=> e.ok ? e.json() : this.preocessError(e))
    } 


    static GetFromCache(url,callback){ 
        if(Vue.prototype.SWEnable==false)
            return;
        caches.open('customerAppJsonData').then(function(cache){ 
            cache.match(url).then(function(response){ 
                if(response){
                    response.json().then(callback)
                } 
            })
        })  
    }

     static fetchWithAuth(url, setting){ 
        return fetch(url, setting).then(e => {
            if(e.status === 401 && localStorage.accessId){
                return this.auth(url, setting);
            }        
            return e.json()
        });
    }

    static auth(url, setting){
        appInsights.trackTrace({message: 'Relogin... accessId:' + localStorage.accessId + '; token:' + localStorage.token}); 
        return store.dispatch("login/auth", {tokenId: localStorage.accessId}).then(e => {
            appInsights.trackTrace({message: 'Relogined! accessId:' + localStorage.accessId + '; token:' + localStorage.token});  
            setting.headers = new Headers();
            setting.headers.append("Content-Type", "application/json");
            setting.headers.append('Authorization','Bearer '+localStorage.token) 

            return fetch(url, setting).then(e => e.ok ? e.json() : this.preocessError(e));
        });
    }

    static preocessError(error){
       return error.text().then((message)=>
            Promise.reject({error: error.status, message}) 
        )
        
    }

    static proccessResponse(res){
        if(!res.ok){
            return this.preocessError(e);
        }
        return res.json().then(data => {
            if(!data.success && hasValidationErrors(data)){
                notify.error(validationMessage(data))
            }

            return Promise.resolve(data)
        })
    }
}




// WEBPACK FOOTER //
// ./scripts/src/shared/base.requests.js